function load() {
  var container =  document.getElementById("container");
  var ban = document.getElementById("ban");
  var banner = document.getElementById("banner");
  var li = document.querySelectorAll("#banner li");
  var spanNode = document.querySelectorAll("#buttons span");
  var text = document.getElementsByClassName("text")[0];

  var prev = document.getElementById('prev');
  var next = document.getElementById('next');

  var index = 1;

  var timer = 0;

  banner.style.height = text.offsetHeight + "px";
  banner.style.width = text.offsetWidth * li.length + 30 * (li.length - 1) + "px";
  if(document.body.clientWidth<768){
    banner.style.width = text.offsetWidth * li.length +  8* (li.length - 1) + "px";
  }

  function animate(offset) {
    banner.style.transition = "0.5s";
    banner.style.left = -parseInt(offset )* index + "px";
  }

  next.onclick = function () {
    if(index == spanNode.length){
      index = 0;
    }
    index ++;
    var maxWidth=banner.offsetWidth;

    if(maxWidth-parseInt((li[0].offsetWidth) * index)<container.offsetWidth){
      banner.style.left = -(maxWidth-container.offsetWidth) + "px";
      index=-1
    }else{
      animate(text.offsetWidth)
    }
  }

  prev.onclick = function () {
    var maxWidth=banner.offsetWidth;
    if(index <= 0){
      index = li.length-3;
      
      banner.style.left = -(maxWidth-container.offsetWidth) + "px";
      console.log(maxWidth)
      console.log(container.offsetWidth)
      return false;
    }
    index--;
    animate(text.offsetWidth)
  }



  function play() {
    timer = setInterval(function () {
      banner.style.transition = "0.5s";
      setTimeout(function () {
        next.onclick();
      },200)
    },3500);
  }

  container.onmouseover = function () {
    clearInterval(timer);
  }
  container.onmouseout = function () {
    play()
  }

}

export {
  load
}


// WEBPACK FOOTER //
// ./src/views/promotion/Bbc/ReviewText.js